import title from './Title';
import subtitle from './Subtitle';
import heading from './Heading';

export default angular.module('edge.platform.widgets.titles', ['angular-table'])
    .directive('gwTitle', title)
    .directive('gwSubtitle', subtitle)
    .directive('gwHeading', heading);